































































































import Vue from 'vue'
import { sic, tool } from '@rhitics/core'
import RtsDataTable from '@rhitics/vue/components/RtsDataTable.vue'
import AddAssetsDialog from './AddAssetsDialog.vue'
import AssetsTableSelectors from './AssetsTableSelectors.vue'
import InputListenerButton from './InputListenerButton.vue'
import { debounce, isEqual, cloneDeep } from 'lodash'

export type verifyStatus = boolean | 'all'
export interface AssetsSearchPayload {
  isVerified: verifyStatus
  batchs: Array<string>
  keeperDepartments: Array<string>
  keepers: Array<string>
}

export default Vue.extend({
  name: 'AssetsTable',
  components: {
    AddAssetsDialog,
    AssetsTableSelectors,
    InputListenerButton,
    RtsDataTable
  },
  data() {
    return {
      alert: {
        open: false,
        status: 'error' as 'error' | 'success' | 'warning',
        message: 'hello world'
      },
      currentOption: {} as AssetsSearchPayload,
      files: [] as Array<any>,
      conditionUpdate: '' as any,
      tableData: [] as Array<any>,
      loading: true,
      search: '',
      headers: [
        { text: '批次', value: 'batch', width: 70, useSlot: true },
        { text: '編號', value: 'number', width: 60, useSlot: true },
        { text: '名稱', value: 'name', width: 100, useSlot: true },
        { text: '已驗數量', value: 'verifiedQuantity', sortable: false, width: 50, useSlot: true },
        { text: '保管人', value: 'keeper', width: 75, useSlot: true },
        { text: '保管部門', value: 'keeperDepartment', width: 75, useSlot: true },
        // { text: '驗證狀態', value: 'verified', width: 50 },
        { text: '驗證年', value: 'verifiedYear', width: 50, useSlot: true }
      ],
      showSearch: false,
      selectedRow: [] as any[],
      printBarcodeLoading: false
    }
  },
  computed: {
    tableOptions(): any {
      return {
        loading: this.loading,
        search: this.search,
        headers: this.headers,
        items: this.tableData,
        'no-data-text': '無搜尋結果',
        'loading-text': '正在查詢...',
        'items-per-page': 25,
        'show-select': true
      }
    }
  },
  watch: {
    'alert.open'(val) {
      val &&
        setTimeout(() => {
          this.alert.open = false
        }, 2000)
    }
  },
  created() {
    // @ts-ignore
    this.conditionUpdate = debounce(this.updateDataTable, 500)
  },
  methods: {
    async updateDataTable(parm: AssetsSearchPayload | undefined) {
      this.loading = true
      this.currentOption = parm || this.currentOption
      await sic.asset
        .get(this.currentOption)
        .then(response => {
          this.tableData = response.data
        })
        .catch(reson => {
          this.promtAlert('搜尋失敗!', 'error')
        })
      this.loading = false
    },
    async scan(input: string, reverse = false) {
      if (input.length === 10) {
        sic.operate
          .scan(this.currentOption.batchs[0], input, reverse ? 1 : 0)
          .then(response => {
            this.updateDataTable(this.currentOption)
            this.promtAlert(response.message, response.status)
          })
          .catch(reson => {
            this.promtAlert('更新失敗!', 'error')
          })
      } else {
        this.promtAlert('找不到此編號!', 'error')
      }
    },
    async generateBarcodePdf() {
      this.printBarcodeLoading = true
      try {
        const barcodes = this.selectedRow.map(row => ({
          template: 'property',
          type: 'datamatrix',
          title: row.number,
          value: row.number,
          quantity: 1
        }))
        const response = await tool.generatePropertySticker(barcodes)
        this.download(response.data.url)
        this.promtAlert(response.data.message, 'success')
      } catch (error) {
        this.promtAlert('Generate fail please contect IT. Message: ' + error.message, 'error')
      }
      this.printBarcodeLoading = false
    },
    download(url: string) {
      var link = document.createElement('a')
      link.target = '_blank'
      link.href = url
      link.click()
    },
    promtAlert(message: string, status: 'error' | 'warning' | 'success') {
      let context = new AudioContext()
      let o = context.createOscillator()
      let g = context.createGain()
      const statuses = {
        error: 500,
        warning: 1000,
        success: 1500
      }
      o.connect(g)
      o.frequency.value = statuses[status]
      g.connect(context.destination)
      o.start(0)
      g.gain.exponentialRampToValueAtTime(0.00001, context.currentTime + 1)
      this.alert.message = message
      this.alert.status = status
      this.alert.open = !this.alert.open
    },
    
    updateSelectedRows(updatedRows) {
      if (isEqual(this.selectedRow, updatedRows)) return
      this.selectedRow = cloneDeep(updatedRows)
    }
  }
})
